/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync>): BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync(), model);
        BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync>): BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync.newInstance(<BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
